import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'
// クリエイターと企業の銀行コード入力に使用
export default class extends Controller {
  static targets = ['bank', 'branch']

  connect() {
    const bankConfig = {
      valueField: 'code',
      labelField: 'name',
      searchField: 'name',
      allowEmptyOption: false,
      plugins: ['dropdown_input'],
      load: function (query, callback) {
        let url = '/banks?name_like=' + encodeURIComponent(query)
        fetch(url)
          .then((response) => response.json())
          .then((json) => {
            callback(json)
          })
          .catch(() => {
            callback()
          })
      },
      render: {
        no_results: function (data, escape) {
          return (
            '<div class="no-results">検索結果が見つかりませんでした: "' +
            escape(data.input) +
            '"</div>'
          )
        }
      }
    }
    const branchConfig = {
      valueField: 'code',
      labelField: 'name',
      searchField: 'name',
      render: {
        no_results: function (data, escape) {
          return (
            '<div class="no-results">検索結果が見つかりませんでした: "' +
            escape(data.input) +
            '"</div>'
          )
        }
      }
    }
    this.bankSelect = new TomSelect(this.bankTarget, bankConfig)
    this.branchSelect = new TomSelect(this.branchTarget, branchConfig)
  }

  disconnect() {
    this.bankSelect.destroy()
    this.branchSelect.destroy()
  }

  fetchBranchOptions(e) {
    const bankCode = e.target.value
    if (!bankCode) {
      this.branchSelect.clear()
      this.branchSelect.clearOptions()
      return
    }
    let url = `/banks/${bankCode}/branches`
    fetch(url)
      .then((response) => response.json())
      .then((json) => {
        this.branchSelect.clear()
        this.branchSelect.clearOptions()
        this.branchSelect.addOptions(json)
      })
      .catch(() => {})
  }
}
